import { api } from './client';

export const searchCustomers = async (query) => {
  return api.get("/customers/search/", {
    params: { q: query },
  });
};

export const updateCustomer = async (customerId, customerData) => {
  return api.put(`/customers/${customerId}/`, customerData);
};
